import { render } from "./NearbyHotels.vue?vue&type=template&id=5dde4dda"
import script from "./NearbyHotels.vue?vue&type=script&lang=js"
export * from "./NearbyHotels.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__